import React from "react";
import LegalLayout from "./LegalLayout";
import useSeo from "../lib/useSeo";
import { buildCanonical } from "../lib/insightsLinks";

export default function LegalTerms() {
  useSeo({
    title: "Terms & Conditions — Linked2Marketing",
    description:
      "The terms and conditions governing your use of the Linked2Marketing website, including acceptable use, intellectual property, and limitation of liability — under English law.",
    canonical: buildCanonical("/terms"),
    ogType: "website",
  });

  return (
    <LegalLayout
      eyebrow="Legal · English law"
      title="Terms & Conditions"
      intro="These terms govern your use of the Linked2Marketing website. By using this site, you agree to these terms. They are written in plain English and governed by the laws of England and Wales."
      lastUpdated="28 February 2026"
      testid="page-terms"
    >
      <h2>1. About us</h2>
      <p>
        Linked2Marketing is a digital systems studio based in the United
        Kingdom. The contact email for all matters relating to this website is{" "}
        <a href="mailto:contact@linked2marketing.com">contact@linked2marketing.com</a>.
      </p>

      <h2>2. Use of this website</h2>
      <p>
        You may use this website to read our content, to learn about our work,
        and to send us an enquiry. You agree to use the site lawfully and not
        to interfere with its operation. You agree not to attempt to gain
        unauthorised access to any part of the site, to its administrative
        systems, or to its underlying infrastructure.
      </p>

      <h2>3. Content and intellectual property</h2>
      <p>
        All content on this site — including written articles, design,
        photography, logos, code, and visual identity — is the property of
        Linked2Marketing or its licensors, and is protected by UK and
        international copyright law. You may share short excerpts with proper
        attribution and a link back to the original page. You may not republish
        substantial portions, repurpose our content for commercial training
        datasets, or remove our branding from any materials.
      </p>

      <h2>4. Enquiries and follow-up</h2>
      <p>
        Submitting an enquiry through this website does not create a
        contractual relationship. We will respond personally, usually within
        one business day. Any subsequent work will be governed by a separate
        written engagement letter or contract.
      </p>

      <h2>5. Third-party links</h2>
      <p>
        This site links to external resources, including GuestVoyages,
        Calendly, and references to third-party platforms. We are not
        responsible for the content, accuracy, or practices of any third-party
        site. Following an external link is at your own discretion.
      </p>

      <h2>6. Editorial accuracy</h2>
      <p>
        We aim for our Insights articles to be calm, considered, and
        commercially accurate. They are intended as general perspective, not as
        regulatory, legal, financial, or professional advice. You should always
        take specialist advice before making business decisions based on
        anything you read here.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, Linked2Marketing is not liable
        for any indirect, incidental, or consequential loss arising from your
        use of, or reliance on, the content of this website. Nothing in these
        terms excludes or limits liability for death or personal injury caused
        by negligence, or for fraud or fraudulent misrepresentation, or for any
        liability that cannot be excluded by English law.
      </p>

      <h2>8. Changes to these terms</h2>
      <p>
        We may revise these terms from time to time. The most recent version
        will always be available at this URL and will be marked with the “Last
        updated” date above.
      </p>

      <h2>9. Governing law</h2>
      <p>
        These terms and any dispute arising from them are governed by the laws
        of England and Wales, and any disputes will be subject to the exclusive
        jurisdiction of the courts of England and Wales.
      </p>

      <h2>10. Contact</h2>
      <p>
        Any questions about these terms can be sent to{" "}
        <a href="mailto:contact@linked2marketing.com">contact@linked2marketing.com</a>.
      </p>
    </LegalLayout>
  );
}
